<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#personalList" active>Personal List</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Personal List</h1>
    <p>Your personally tailored list, just for you.</p>
    <hr>
    <div>
      <div class="input-container">
        <b-row>
          <b-col class="col-2">
            <label class="input-title">Sort by</label>
          </b-col>
          <b-col>
            <b-form-select v-model="sortTypeSelected" :options="sortTypeOptions"
                           @change="getPersonalListData(sortTypeSelected)"></b-form-select>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="list-container">
      <div v-if="showPlaceholderImage && !hideWhenInitialLoad" class="no-personal-list-container">
        <b-img class="no-personal-list-picture" :src="require('../../assets/no_personal_list.png')"
               alt="No personal list picture"></b-img>
        <h2>No Personal List</h2>
        <p>Your personal to-do list will be shown here</p>
      </div>
      <personal-list-cell v-else v-for="personalList in personalListDocuments" :key="personalList.toDoListId"
                          :listDetails="personalList"></personal-list-cell>
    </div>
    <fab
        position="bottom-right"
        bg-color="#565A7B"
        icon-size="small"
        @click.native="openCreationModal"
    ></fab>
  </div>
</template>

<script>
  import PersonalListCell from "../table_cells/list_cells/PersonalListCell.vue"
  import {mapActions, mapGetters} from "vuex"
  import {db} from "../../main"
  import fab from 'vue-fab'

  export default {
    data() {
      return {
        showPlaceholderImage: null,
        hideWhenInitialLoad: true,
        personalListDocuments: null,
        sortTypeSelected: 'Creation time (Ascending)',
        sortTypeOptions: [
          {value: 'Creation time (Ascending)', text: 'Creation time (Ascending)'},
          {value: 'Creation time (Descending)', text: 'Creation time (Descending)'},
          {value: 'List name (Ascending)', text: 'List name (Ascending)'},
          {value: 'List name (Descending)', text: 'List name (Descending)'}
        ],
      }
    },
    components: {
      personalListCell: PersonalListCell,
      fab
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      openCreationModal() {
        this.$store.dispatch('setupCreationModal')
        this.showModal('creation-modal')
      },
      getPersonalListData(sortTypeSelected) {
        if (sortTypeSelected === 'Creation time (Ascending)') {
          this.$bind(
            'personalListDocuments',
            db
              .collection('personal_to_do_lists')
              .where("ownerId", '==', this.$store.getters.user.data.id)
              .orderBy("toDoListCreationTime", 'asc')
          ).then(() => {
            if (this.personalListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortTypeSelected === 'Creation time (Descending)') {
          this.$bind(
            'personalListDocuments',
            db
              .collection('personal_to_do_lists')
              .where("ownerId", '==', this.$store.getters.user.data.id)
              .orderBy("toDoListCreationTime", 'desc')
          ).then(() => {
            if (this.personalListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortTypeSelected === 'List name (Ascending)') {
          this.$bind(
            'personalListDocuments',
            db
              .collection('personal_to_do_lists')
              .where("ownerId", '==', this.$store.getters.user.data.id)
              .orderBy("toDoListName", 'asc')
          ).then(() => {
            if (this.personalListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortTypeSelected === 'List name (Descending)') {
          this.$bind(
            'personalListDocuments',
            db
              .collection('personal_to_do_lists')
              .where("ownerId", '==', this.$store.getters.user.data.id)
              .orderBy("toDoListName", 'desc')
          ).then(() => {
            if (this.personalListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      showModal(id) {
        this.$root.$emit('bv::show::modal', id)
      }
    },
    watch: {
      personalListDocuments(newProperties, oldProperties) {
        this.showPlaceholderImage = this.personalListDocuments.length === 0
      }
    },
    mounted() {
      this.getPersonalListData(this.sortTypeSelected)
    }
  }
</script>

<style scoped>
  .no-personal-list-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-personal-list-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .list-container {
    height: 63vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    margin-top: 0.5em;
  }
</style>
